import React from "react";
import styled from "@emotion/styled";

import {Loader} from "@pg-design/loader-module";

interface IProps {
    useTopOffset?: boolean;
    boxShadowCover?: boolean;
    backgroundColor?: string;
}

export const PropertyListLoader = (props: IProps) => {
    return (
        <LoaderWrap backgroundColor={props.backgroundColor} useTopOffset={props.useTopOffset} boxShadowCover={props.boxShadowCover}>
            <Loader />
        </LoaderWrap>
    );
};

interface IThemeProps {
    useTopOffset?: boolean;
    boxShadowCover?: boolean;
    backgroundColor?: string;
}

const LoaderWrap = styled.div<IThemeProps>`
    position: absolute;
    top: ${(props) => (props.useTopOffset ? "54px" : props.boxShadowCover ? "-15px" : "0")};
    left: ${(props) => (props.boxShadowCover ? "-20px" : "0")};
    width: ${(props) => (props.boxShadowCover ? "calc(100% + 40px)" : "100%")};
    height: ${(props) => (props.useTopOffset ? "calc(100% - 64px)" : props.boxShadowCover ? "calc(100% + 17px)" : "100%")};
    display: flex;
    justify-content: center;
    align-items: center;
    background: ${(props) => props.backgroundColor || "#fff"};

    @media (min-width: ${(props) => props.theme.breakpoints.xs}) {
        top: ${(props) => (props.useTopOffset ? "64px" : props.boxShadowCover ? "-15px" : "0")};
    }
`;
import React from "react";
import styled from "@emotion/styled";

import {Loader} from "@pg-design/loader-module";

interface IProps {
    useTopOffset?: boolean;
    boxShadowCover?: boolean;
    backgroundColor?: string;
}

export const PropertyListLoader = (props: IProps) => {
    return (
        <LoaderWrap backgroundColor={props.backgroundColor} useTopOffset={props.useTopOffset} boxShadowCover={props.boxShadowCover}>
            <Loader />
        </LoaderWrap>
    );
};

interface IThemeProps {
    useTopOffset?: boolean;
    boxShadowCover?: boolean;
    backgroundColor?: string;
}

const LoaderWrap = styled.div<IThemeProps>`
    position: absolute;
    top: ${(props) => (props.useTopOffset ? "54px" : props.boxShadowCover ? "-15px" : "0")};
    left: ${(props) => (props.boxShadowCover ? "-20px" : "0")};
    width: ${(props) => (props.boxShadowCover ? "calc(100% + 40px)" : "100%")};
    height: ${(props) => (props.useTopOffset ? "calc(100% - 64px)" : props.boxShadowCover ? "calc(100% + 17px)" : "100%")};
    display: flex;
    justify-content: center;
    align-items: center;
    background: ${(props) => props.backgroundColor || "#fff"};

    @media (min-width: ${(props) => props.theme.breakpoints.xs}) {
        top: ${(props) => (props.useTopOffset ? "64px" : props.boxShadowCover ? "-15px" : "0")};
    }
`;
